import { IScript } from '../../models/IScript';

export function getScriptTypeLabel(script: IScript): string {
    return script?.type === 'transform' ? 'Transform' : 'Script';
}